import * as ShopifyCurrency from '@shopify/theme-currency';

/**
 * Updates the freshpack text based on the given quantity.
 *
 * This method updates the text content of the `freshpackTextWrapper` element
 * with the appropriate translation and counts based on the provided quantity.
 *
 * @param {HTMLElement} element - The element to update the freshpack text for. This can be any parent element of the freshpack text wrapper.
 * @param {number} quantity - The number of items to update the freshpack text for.
 *
 * @returns {void}
 */
const updateFreshpackText = (element, quantity) => {
  if (!element || quantity <= 0) return;
  const freshpackTextWrappers = element.querySelectorAll(
    '[data-freshpack-text-wrapper]'
  );
  if (!freshpackTextWrappers) return;
  const translations = globalThis.PxlApp.translations.freshpackText;

  for (const wrapper of freshpackTextWrappers) {
    let freshPackText = '';

    freshPackText = quantity === 1 ? translations.single : translations.plural;

    const freshpacksPerBox = Number.parseInt(wrapper.dataset.freshpacksPerBox);

    freshPackText = freshPackText.replace('{count}', quantity);
    freshPackText = freshPackText.replace(
      '{freshpacks_count}',
      quantity * freshpacksPerBox
    );

    wrapper.textContent = freshPackText;
  }
};
/**
 * Updates the displayed price based on the given quantity.
 *
 * @param {number} quantity - The quantity of the product.
 * @param {HTMLElement[]} priceElements - The elements to update the price for.
 * @returns {void}
 */
const updatePrice = (quantity, priceElements) => {
  if (!priceElements) return;

  for (const priceElement of priceElements) {
    const moneyFormat = priceElement.dataset.moneyFormat;
    const unitPrice = Number.parseInt(priceElement.dataset.unitPrice);
    const formattedPrice = ShopifyCurrency.formatMoney(
      unitPrice * quantity,
      moneyFormat
    );

    priceElement.textContent = formattedPrice;
  }
};

export { updateFreshpackText, updatePrice };
